// extracted by mini-css-extract-plugin
module.exports = {"benefits__data":"BenefitsList_benefits__data__1iUuZ","benefits__icon":"BenefitsList_benefits__icon__GNkG9"};